import { useEffect, useState } from "react"
import UserContext, { UserContextType } from "../../../contexts/UserContext"
import { useApolloClient } from "@apollo/client/react"
import { Route, Routes, useNavigate } from "react-router-dom"
import FullscreenSpinner from "../../../components/fullscreen-spinner/FullscreenSpinner"
import { gql } from "@apollo/client"
import VpnUsers from "./vpn-users/users-list/VpnUsers"
import Menu from "./menu/Menu"
import LogoBar from "../../../components/logo-bar/LogoBar"
import PaginationContext from "../../../contexts/PaginationContext"
import SystemParameters from "./system-parameters/SystemParameters"
import VpnLogs from "./vpn-logs/logs-list/VpnLogs"
import Users from "./users/users-list/Users"

const TOKEN_QUERY = gql`
    query GetTokenData {
        getTokenData {
            username
        }
    }
`

interface getTokenDataResult {
    getTokenData: {
        username: string
    }
}

export default function Dashboard() {
    const [ userData, setUserData ] = useState<UserContextType>({ username: "" })
    const client = useApolloClient()
    const navigate = useNavigate()

    useEffect(() => {
        const clearStorageAndRedirect = () => {
            localStorage.removeItem(process.env.REACT_APP_SESSION_TOKEN_NAME)
            navigate('/admin')
        }

        const getTokenData = async () => {
            try {
                const data = await client.query<getTokenDataResult>({
                    query: TOKEN_QUERY,
                    fetchPolicy: 'no-cache'
                })

                if(!data.data) {
                    clearStorageAndRedirect()
                    return
                }
                
                const { username } = data.data.getTokenData
                if(username.length < 1) {
                    clearStorageAndRedirect()
                    return
                }

                setUserData({ username })                
            }
            catch(e) {
                clearStorageAndRedirect()
            }
        }

        const token = localStorage.getItem(process.env.REACT_APP_SESSION_TOKEN_NAME) ?? ""
        if(token.length === 0) {
            clearStorageAndRedirect()
        }
        else {
            getTokenData()
        }
    }, [ client, navigate ])
    
    return (
        <UserContext userdata={ userData }>
            <PaginationContext>
                <>
                    <LogoBar />
                    <Menu />
                    {
                        userData.username === ""
                        ?
                            <FullscreenSpinner visible />
                        :
                            <RenderScreen />
                    }
                </>
            </PaginationContext>
        </UserContext>
    )
}

function RenderScreen() {
    return (
        <Routes>
            <Route path="/users" element={ <Users /> } />
            <Route path="/system-parameters" element={ <SystemParameters /> } />
            <Route path="/logs" element={ <VpnLogs /> } />
            <Route path="/" element={ <VpnUsers /> } />
            <Route path="*" element={ <VpnUsers /> } />
        </Routes>
    )
}